import React from 'react';
import { AddCircle } from '@mui/icons-material';
import useBoolState from 'app/hooks/useBoolState.ts';
import { ListItemIcon, ListItemText, ListItemButton } from '@mui/material';
import ScenarioSettingsDialog from '../../../ScenarioEditorPage/ScenarioSettingsDialog/index.ts';
import useStyles from './styles.ts';
import clsx from 'clsx';

import { useTranslation } from 'react-i18next';
import type { I18nScenarioSectionNs } from '@/i18n/dictionaries/interfaces.ts';
import { I18nNamespace } from '@/i18n/types/i18nNamespace.ts';

export default function AddScenarioSection() {
  const [translate] = useTranslation(I18nNamespace.ScenarioSection);

  const [settingsOpen, openSettings, closeSettings] = useBoolState();
  // this is used to provide no id to form when creation is requested
  const classes = useStyles();
  return (<>
    <ListItemButton onClick={openSettings} data-cy="createScenarioButton">
      <ListItemIcon color="primary" className={clsx(classes.iconMWidth24, classes.paddingRight10)}>
        <AddCircle classes={{ root: classes.addBtn }} />
      </ListItemIcon>
      <ListItemText
        classes={{ root: classes.addBtn }}
        primary={translate(nameof.full<I18nScenarioSectionNs>((l) => l.createNewScenario))}
      />
    </ListItemButton>
    <ScenarioSettingsDialog open={settingsOpen} onClose={closeSettings} />
  </>);
}
